const SvgSecure1 = (props) => (
  <>
    <path
      d="M96 104c4.42 0 8-3.58 8-8M96 104c-4.42 0-8-3.58-8-8M96 88c4.31 0 7.81 3.4 7.98 7.67M88.02 95.67C88.2 91.41 91.7 88 96 88M96 280.01v-80M96 0v88.01M96 104.01v80M96 296.01V384"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
    <path
      d="M96 0h96c0 50.51-38.73 91.93-88.02 96M96 0H0c0 50.51 38.73 91.93 88.02 96M103.98 192c49.28-4.07 88.02-45.49 88.02-96h-88M88 96H0c0 50.51 38.73 91.93 88.02 96M88.02 288C38.73 283.93 0 242.51 0 192h88M103.98 288c49.28-4.07 88.02-45.49 88.02-96h-88M88 288H0c0 53.02 42.98 96 96 96s96-42.98 96-96h-88"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
    <path
      d="M88.02 95.67c0 .11-.02.22-.02.33M103.98 95.67c0 .11.02.22.02.33M103.98 191.67c0 .11.02.22.02.33M104 192c0 4.42-3.58 8-8 8M96 184c4.31 0 7.81 3.4 7.98 7.67M96 184c-4.31 0-7.81 3.4-7.98 7.67M88 192c0 4.42 3.58 8 8 8M88.02 191.67c0 .11-.02.22-.02.33M104 288c0-.11-.01-.22-.02-.33M96 296c4.42 0 8-3.58 8-8M88.02 287.67C88.2 283.41 91.7 280 96 280M96 296c-4.42 0-8-3.58-8-8M103.98 287.67c-.18-4.26-3.68-7.67-7.98-7.67M88 288c0-.11.01-.22.02-.33"
      fill="none"
      stroke={props.p50}
      strokeMiterlimit={10}
    />
  </>
);

export default SvgSecure1;
